module.exports = __webpack_public_path__ + "static/media/hoc3.ff831348.webp";